import * as React from "react";
import { useParams } from "react-router";
import { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useGetPaymentConfigQuery } from "../reducers/registerapi";
import { RootState } from "../reducers/index";
import { useAppSelector } from "../store/index";
import Cart from "./checkout/cart";
import CheckoutComponent from "./checkout/checkout";

// If somebody clicks the back button from the receipt page, they will end up
// here and not be back in the cart.
const CheckoutComplete = () => {
    return (
        <div className="container py-3">
            <h3>Checkout Complete</h3>
            <div className="alert alert-warning">
                You have completed your purchase. Please check your email for your receipt. Or <a href="/Client">visit your dashboard</a> to view your program.
            </div>
        </div>
    );
};

export default CheckoutComplete;
